module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedication1a"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_vm._v("For my wife, Stephanie, who is my beloved and my best friend, and has always got my back.")])]), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('p', {
    staticClass: "dedication1"
  }, [_vm._v("For my children, Eian and Michaela, may they never be afraid to be exactly who they are.")]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_vm._v("Most of all for my mother, Erma, who gave to me her love for the written word and taught me how to dream.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ddd2442","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Dedication.vue
// module id = 72
// module chunks = 0